import { render, staticRenderFns } from "./dy-add-customer.vue?vue&type=template&id=196c3081&scoped=true&"
import script from "./dy-add-customer.vue?vue&type=script&lang=js&"
export * from "./dy-add-customer.vue?vue&type=script&lang=js&"
import style0 from "./dy-add-customer.vue?vue&type=style&index=0&id=196c3081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c3081",
  null
  
)

export default component.exports